import React from "react";
import { FiDownload } from "react-icons/fi";
import { useTranslation } from "react-i18next";


import { openS3Document } from "../lib/documents";

function AnalystReport() {
  const { t } = useTranslation();

  const files = [
    {
      key: "analyst_reports/2026/2026_11_04_Rigsave-H1-26-report___btftf4d2.pdf",
      name: "MWB Research - 05/11/2026",
    },
    {
      key: "analyst_reports/2025/20251111_rigsave_H1_report___3maa19s5.pdf",
      name: "MWB Research - 11/11/2025",
    },
    {
      key: "analyst_reports/2025/20250709_Rigsave_FY24_report_3sihabqe.pdf",
      name: "MWB Research - 09/07/2025",
    },
    {
      key: "analyst_reports/2024/26012024_research_alsterresearch.pdf",
      name: t("main.analystReports.documents.alsterResearch26012024"),
    },
    {
      key: "analyst_reports/2024/2024_07_18_mwb_research.pdf",
      name: t("main.analystReports.documents.mwbResearch18072024"),
    },
    {
      key: "analyst_reports/2024/2024_11_13_MWB_Research.pdf",
      name: t("main.analystReports.documents.mwbResearch13112024"),
    },
  ];

  return (
    <main className="analyst-page">
      <section className="analyst-hero">
        <div>
          <h1>{t("main.analystReports.title")}</h1>
          <span />
        </div>
      </section>

      <section className="analyst-list-section">
        <div className="analyst-list">
          {files.map((pdf) => (
            <div className="analyst-row" key={pdf.key}>
              <span>{pdf.name}</span>

              <a
                href="/"
                aria-label={`${t("main.common.download")} ${pdf.name}`}
                onClick={(event) => openS3Document(event, pdf.key)}
              >
                <FiDownload />
              </a>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default AnalystReport;